<template>
  <div v-if="!profileInfo.is_done_step">
    <resendEmail
      v-if="nextStep && nextStep.name === 'verify_email'"
      :card="card"
    />
    <registerStep
      v-else-if="nextStep && nextStep.text_step"
      :step-data="nextStep"
    />
  </div>
</template>
<script>
import resendEmail from '@/views/theme1/components/registerSteps/resendEmail.vue'
import registerStep from '@/views/theme1/components/registerSteps/registerStep.vue'
import registerSteps from '@/views/logics/components/registerSteps/registerSteps'

export default {
  components: { resendEmail, registerStep },
  mixins: [registerSteps],
}
</script>
